module.exports = __webpack_public_path__ + "img/ic-scooter.9687518f.svg";